import React, { Node } from 'react';
import _omit from 'lodash.omit';
import { AuthorisationConsumer } from '../AuthorisationWrapper';
import hasPermission from './utils/hasPermission';








export default function requiresPermission({
  ComponentToRender,
  requiredPermission,
  Fallback,
  isRoute
}) {
  return (props) =>
  <AuthorisationConsumer>
      {({ selectedOrganisation: { permissions: orgPermissions } }) => {
      const { permissions: resourcePermissions } = props;

      if (isRoute && hasPermission(requiredPermission, orgPermissions) ||
      hasPermission(requiredPermission, resourcePermissions)) {
        return <ComponentToRender {..._omit(props, 'permissions')} />;
      }

      return Fallback ? <Fallback {...props} /> : null;
    }}
    </AuthorisationConsumer>;

}